var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","mx-0":""}},[_c('div',{staticStyle:{"width":"14em","float":"left"}},[_vm._v(_vm._s(_vm.sp.service))]),_vm._v(" "),_c('div',{staticStyle:{"width":"19em","float":"left"},domProps:{"innerHTML":_vm._s(_vm.date())}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-557d222e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Person/ShowServicePeriod.vue
// module id = null
// module chunks = 